module.exports = __webpack_public_path__ + "img/step5.af235b51.jpg";